import React from "react";
import ReactDOM, { hydrateRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
let ssrState = null;
try {
  const stateElement = document.getElementById("aran-ssr-state");
  if (stateElement?.textContent) ssrState = JSON.parse(stateElement.textContent);
} catch {
  // Invalid or stale SSR state falls back to the established client render.
  rootElement.innerHTML = "";
}

const appTree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App initialData={ssrState?.initialData} initialPageData={ssrState?.initialPageData} />
    </QueryClientProvider>
  </React.StrictMode>
);

if (ssrState?.initialData) {
  hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}
